import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BoostIllustration from '../BoostIllustration';
const BoostSuccessModal = ({ onRequestClose })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: true,
        variant: "vertical",
        image: /*#__PURE__*/ React.createElement(BoostIllustration, null),
        onRequestClose: onRequestClose,
        title: t('boostDeviation.successModal.title'),
        message: t('boostDeviation.successModal.message'),
        footerButtons: [
            /*#__PURE__*/ React.createElement(ConfirmButton, {
                key: "confirm",
                onClick: onRequestClose
            }, t('common.gotIt'))
        ]
    });
};
BoostSuccessModal.displayName = 'BoostSuccessModal';
export default BoostSuccessModal;

//# sourceMappingURL=BoostSuccessModal.js.map